import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';

@Component({
  selector: 'app-kiosk-selection-group-wrapper-atom',
  imports: [ContentBuilderColorPipe],
  template: `
    <div
      class="mb-10 rounded-lg px-5 pb-3"
      [style.borderColor]="secondaryColor() | contentBuilderColor"
    >
      <ng-content> </ng-content>
    </div>
  `,
})
export class KioskSelectionGroupWrapperComponent {
  secondaryColor = input<IContentBuilderFieldColor>();
}
